// Parts of a job that can be crewed independently (mirrors the backend WorkSection
// enum in Models/ProjectCrewAssignment.cs). `key` is what crosses the wire — both
// the assignment API and the "section" field on a SendText automation action.
//
// Deliberately the same vocabulary as the "additional work" flags already on
// Project, with Roof added as the section those are additional to.
export const WORK_SECTIONS = [
  { key: 'Roof',          label: 'Roof' },
  { key: 'Gutters',       label: 'Gutters' },
  { key: 'GutterRepair',  label: 'Gutter Repair' },
  { key: 'Siding',        label: 'Siding' },
  { key: 'ChaseCover',    label: 'Chase Cover' },
  { key: 'Interior',      label: 'Interior' },
  { key: 'WindowScreens', label: 'Window Screens' },
  { key: 'WindowTrim',    label: 'Window Trim' },
  { key: 'StandingSeam',  label: 'Standing Seam' },
  { key: 'FlatRoof',      label: 'Flat Roof' },
];

export const workSectionLabel = (key) =>
  WORK_SECTIONS.find(s => s.key === key)?.label ?? key ?? '';
